import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils/Styles';

const ArrowRight = ({ fill, ...props }) => (
	<svg width="1em" height="1em" viewBox="0 0 13 10" {...props}>
		<path
			d="M8.28 9.28l4-4a.74.74 0 00.163-.245l.004-.01a.75.75 0 000-.548l-.004-.012a.771.771 0 00-.163-.246l-4-4a.749.749 0 10-1.06 1.06L9.94 4H.75a.75.75 0 000 1.5h9.19L7.22 8.22a.748.748 0 000 1.06.749.749 0 001.06 0"
			fill={fill}
			fillRule="evenodd"
		/>
	</svg>
);

ArrowRight.defaultProps = {
	fill: getColor("gray"),
};

ArrowRight.propTypes = {
	fill: PropTypes.string,
};

export default ArrowRight;
